import { FileText, Download } from "lucide-react";
import SEO from "@/components/SEO";

const ITEMS = [
  { title: "Sample Inspection Report", desc: "A redacted example of a Hurtler mold assessment report." },
  { title: "Sample Mold Remediation Protocol", desc: "Reference protocol structured per IICRC S520." },
  { title: "Homeowner Mold Guide", desc: "A calm, science-based primer for property owners." },
  { title: "Property Manager Guide", desc: "Tactical playbook for multi-tenant and commercial portfolios." },
  { title: "Water Damage Guide", desc: "Category 1/2/3 explained — and what to do in the first 24 hours." },
  { title: "Indoor Air Quality Guide", desc: "Practical IAQ framework for facilities and homeowners." },
  { title: "Buyer Inspection Guide", desc: "Pre-purchase environmental assessment essentials." },
  { title: "Commercial IAQ Guide", desc: "Designing IAQ programs for offices, schools, and healthcare." },
];

export default function Resources() {
  return (
    <div data-testid="resources-page">
      <SEO
        title="Download Center — Sample Reports, Guides, Protocols"
        description="Free downloads: sample inspection reports, mold remediation protocols, homeowner guides, property manager playbooks, water damage and indoor air quality guides."
        path="/resources"
      />
      <section className="bg-[#F8FAFC] py-24">
        <div className="container-x">
          <div className="overline mb-5">Download center</div>
          <h1 className="font-display text-5xl sm:text-6xl font-extrabold tracking-tight text-[#0F172A] leading-[1.05] max-w-4xl">
            Free guides, sample reports, and protocols.
          </h1>
          <p className="mt-8 text-lg text-slate-600 max-w-2xl leading-relaxed">
            Premium downloads are released as our learning library expands.
          </p>
        </div>
      </section>
      <section className="section-pad bg-white">
        <div className="container-x grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map((it, i) => (
            <div key={it.title} data-testid={`resource-${i}`} className="card-soft p-7">
              <FileText className="w-7 h-7 text-[#7C3AED] mb-4" />
              <h3 className="font-display font-bold text-lg text-[#0F172A]">{it.title}</h3>
              <p className="text-sm text-slate-600 mt-3 leading-relaxed">{it.desc}</p>
              <button
                data-testid={`resource-cta-${i}`}
                disabled
                className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#7C3AED] opacity-70 cursor-not-allowed"
              >
                <Download className="w-4 h-4" /> Coming soon
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
